module.exports = __webpack_public_path__ + "img/4.e43dc38a.jpg";